import {useEffect,useRef,useState} from 'react';
import {ArrowLeft,ExternalLink,X} from 'lucide-react';
import IndependentAutoPanel from './IndependentAutoPanel.jsx';

export default function LocalGenerator({onStatus,onBack}) {
  const [room,setRoom]=useState(true);
  const [width,setWidth]=useState(()=>Math.max(400,Number(localStorage.getItem('panel-width'))||440));
  const dragging=useRef(false);
  function resize(value) {
    const next=Math.max(400,Math.min(innerWidth*.65,value));
    setWidth(next);localStorage.setItem('panel-width',String(next));
  }
  useEffect(()=>{
    const move=event=>{if(dragging.current)resize(event.clientX);};
    const end=()=>{dragging.current=false;document.body.style.cursor='';};
    addEventListener('pointermove',move);addEventListener('pointerup',end);
    return ()=>{removeEventListener('pointermove',move);removeEventListener('pointerup',end);end();};
  },[]);
  return <main className={`generator local-generator ${room?'split':'wide'}`} style={{'--panel-width':`${width}px`}}>
    <div className="mobile-brand"><img src="/logo.webp" alt="Trader"/></div>
    <button className="secondary mobile-back" onClick={onBack}><ArrowLeft size={16}/> Voltar</button>
    <aside className="generator-panel"><IndependentAutoPanel onStatus={onStatus}/></aside>
    <div className="resize-handle" role="separator" aria-label="Redimensionar painel" aria-orientation="vertical" tabIndex={0}
      onPointerDown={event=>{dragging.current=true;event.currentTarget.setPointerCapture(event.pointerId);document.body.style.cursor='col-resize';}}
      onKeyDown={event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();resize(width+(event.key==='ArrowRight'?20:-20));}}}/>
    {room?<section className="broker-room"><div className="room-title"><b>Polarium</b><button onClick={()=>setRoom(false)}><X size={13}/> Ocultar sala</button></div>
      <iframe src="https://trade.polariumbroker.com/traderoom/" title="Sala da Polarium — serviço externo" referrerPolicy="strict-origin-when-cross-origin"/>
      <div className="room-footer">Polarium · dados e execução Demo conectados diretamente ao gerador local.</div></section>
      :<button className="outline show-room" onClick={()=>setRoom(true)}><ExternalLink size={15}/> Mostrar sala Polarium</button>}
  </main>;
}

export function LocalBrokerPage({integration,onBack,onGenerator}) {
  return <main className="page">
    <div className="page-heading"><button className="icon" aria-label="Voltar" onClick={onBack}><ArrowLeft/></button><div><h1>Conexão Polarium</h1><p className="muted">Dados diretos para o algoritmo local.</p></div></div>
    <section className="card broker-card"><div className="broker-brand"><span className="broker-logo">P</span><div><h2>Polarium</h2><span className="status-pill">{integration?.linked?'Conectada diretamente · Demo':'Sessão não conectada'}</span></div></div>
      <p>O gerador analisa as velas da Polarium no próprio servidor. Conecte a sessão da corretora no gerador para buscar oportunidades e configurar as entradas em Demo.</p>
      <button className="primary" onClick={onGenerator}>Abrir gerador local</button>
      <a className="text-button" href="https://trade.polariumbroker.com/traderoom/" target="_blank" rel="noreferrer">Abrir sala da Polarium <ExternalLink size={14}/></a>
    </section>
  </main>;
}
